/* Analytics consent and anonymous visitor ID management */

// Cookie helpers
function getCookie(name) {
  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  } catch (_) {}
  return null;
}

function setCookie(name, value, days) {
  try {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
  } catch (_) {}
}

function deleteCookie(name) {
  try {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  } catch (_) {}
}

export function isAnalyticsAllowed() {
  try {
    return getCookie("rl_analytics_ok") === "1";
  } catch (_) {
    return false;
  }
}

export function hasAnalyticsChoice() {
  try {
    const value = getCookie("rl_analytics_ok");
    return value === "1" || value === "0";
  } catch (_) {
    return false;
  }
}

export function setAnalyticsAllowed(allowed) {
  setCookie("rl_analytics_ok", allowed ? "1" : "0", 540); // ~18 months
}

function base64Url(bytes) {
  const bin = String.fromCharCode.apply(null, bytes);
  // btoa might throw in some older browsers; guard it
  let b64 = btoa(bin);
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function generateVisitorId() {
  try {
    const arr = new Uint8Array(16); // 128-bit
    (self.crypto || window.crypto).getRandomValues(arr);
    return base64Url(Array.from(arr));
  } catch (e) {
    // Fallback: timestamp + random
    return (
      Math.random().toString(36).slice(2) +
      Date.now().toString(36) +
      Math.random().toString(36).slice(2)
    ).slice(0, 32);
  }
}

export function getVisitorId() {
  // Primary: cookie; Secondary: localStorage; if missing and consent given, generate and persist
  try {
    let vid = getCookie("visitor_id");
    if (vid) return vid;
    try {
      const ls = localStorage.getItem("visitor_id");
      if (ls) {
        // sync back to cookie with full expiry
        setCookie("visitor_id", ls, 540);
        return ls;
      }
    } catch (_) {}
    // If analytics not allowed, do not generate a new ID
    if (!isAnalyticsAllowed()) return null;
    const newId = generateVisitorId();
    setCookie("visitor_id", newId, 540);
    try { localStorage.setItem("visitor_id", newId); } catch (_) {}
    return newId;
  } catch (_) {
    return null;
  }
}

export function ensureVisitorId() {
  let vid = getVisitorId();
  if (!vid && isAnalyticsAllowed()) {
    vid = generateVisitorId();
    setCookie("visitor_id", vid, 540);
    try { localStorage.setItem("visitor_id", vid); } catch (_) {}
  }
  return vid;
}

export function clearVisitorId() {
  try { localStorage.removeItem("visitor_id"); } catch (_) {}
  deleteCookie("visitor_id");
}